'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import HelpText from './HelpText';
var StyledLoadingContainer = styled(UIFlex).withConfig({
  displayName: "LoadingContainer__StyledLoadingContainer",
  componentId: "fuocmh-0"
})(["position:absolute;width:100%;height:100%;align-items:center;"]);
var LoadingContent = styled.div.withConfig({
  displayName: "LoadingContainer__LoadingContent",
  componentId: "fuocmh-1"
})(["height:50px;text-align:center;"]);

var LoadingContainer = function LoadingContainer(_ref) {
  var displayHelpText = _ref.displayHelpText;
  return /*#__PURE__*/_jsx(StyledLoadingContainer, {
    align: "center",
    direction: "column",
    justify: "center",
    children: /*#__PURE__*/_jsx(LoadingContent, {
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered",
        showLabel: displayHelpText,
        label: HelpText
      })
    })
  });
};

export default LoadingContainer;